import * as Time from 'web-app/react/components/form-elements/time/time';

import {type LocalTimeValue} from './timepicker';

export const timeStringToValue = (time?: string | null) => {
    if (!time) {
        return null;
    }
    return Time.fromTimeString(time);
};

export const timeValueToString = (time: LocalTimeValue | null) => (time ? `${time.hours}:${time.minutes}` : null);
